import styled from 'styled-components'
import {
  center,
  hFlex,
  overlay,
} from '../../../../../../../../../../Styles/style-helpers'

export const ReviewEl = styled.div`
  display: block;
  position: relative;
  width: 100%;
  margin-top: 1em;
  background: black;
  border-radius: 1em;
  overflow: hidden;

  &:after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }

  .notFound {
    color: white;
    ${center};
  }

  .videoContent {
    ${overlay};
    z-index: 1;

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;

      .vjs-icon-placeholder {
        font-family: 'VideoJS' !important;
      }
    }
  }

  .videoControls {
    ${overlay};
    z-index: 2;
    ${hFlex};
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(5px);

    button {
      transform: scale(2);
    }
  }
`
